import LebonCoin from '../images/leboncoin.png';
import Ocaze from '../images/ocaze.png';
import facebook from '../images/fbc.png';
import twitter from '../images/twit.png';
import gitgub from '../images/github.jpeg';
import kaggle from '../images/kaggle.png';
import fetchData from '../images/fetch-data.jpeg'
export const SliderData = [
  
  {
    title: 'Take a look of Leboncoin clone one of the best french e-commerce website',
    image:LebonCoin,
    path: 'https://lbc-clone-2d0ea.web.app/',
    alt: 'lebonCoin',
    label:'View site'

  },
  {
    title: 'Meet my first website project with ReactJs and firebase  ',
    image:Ocaze,
    path: 'https://ocaze-aa6b6.web.app/',
    alt: 'Ocaze',
    label:'View site'
  },
  {
    title: 'Example of feching data and displaying it using Redux ',
    image:fetchData,
    path: 'https://fakeshop-c76f7.web.app/',
    alt: 'FakeShop',
    label:'View site'
  }
]
export const Sm = [
  {
    image: facebook,
    title: 'facebook',
    alt: 'fb',
    desc: 'facebook',
    link:'https://www.facebook.com'
  },
  { image: twitter,
    title: 'Twitter',
    alt: 'fb',
    desc: 'Follow me on Twitter',
    link:'https://twitter.com/'
},
  { image: gitgub,
    title: 'Github',
    alt: 'gb',
    desc: 'Here you can find codes and more!',
    link:'https://github.com/smcndiaye'
  },
  { image: kaggle,
    title: 'kaggle',
    alt: 'kaggle ',
    desc: 'Learn,practice and share your  data science projects',
    link:'https://www.kaggle.com/modoucair'

  },

]